// Display formatting. Demo analytics can use NOW; relative labels use the live clock.

export const now = () => new Date();

export const NOW = new Date('2026-09-14T12:00:00Z');

export function relTime(iso: string | number | Date) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '—';
  const current = now();
  const diff = (current.getTime() - d.getTime()) / 1000;
  if (diff < -60) return 'in ' + dur(-diff * 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
  const days = Math.floor((startOfDay(current).getTime() - startOfDay(d).getTime()) / 86400000);
  if (days === 0) return Math.floor(diff / 3600) + 'h ago';
  if (days === 1) return 'Yesterday';
  if (days < 7) return days + ' days ago';
  if (days < 14) return 'Last week';
  if (days < 30) return Math.floor(days / 7) + ' weeks ago';
  return shortDate(iso);
}

export function elapsedDaysHours(iso: string | number | Date, now = Date.now()) {
  if (!iso) return '—';
  const started = new Date(iso).getTime();
  if (!Number.isFinite(started)) return '—';
  const minutes = Math.max(0, Math.floor((now - started) / 60000));
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m ago`;
  return `${Math.floor(hours / 24)}d ${hours % 24}h ago`;
}

function startOfDay(d: Date) { const x = new Date(d); x.setUTCHours(0, 0, 0, 0); return x; }

export function shortDate(iso: string | number | Date) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
}

export function dateTime(iso: string | number | Date) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
}

export function dur(ms: number) {
  if (ms == null) return '—';
  const s = Math.round(ms / 1000);
  if (s < 60) return s + 's';
  const m = Math.floor(s / 60);
  if (m < 60) return m + 'm ' + String(s % 60).padStart(2, '0') + 's';
  return Math.floor(m / 60) + 'h ' + String(m % 60).padStart(2, '0') + 'm';
}

export function money(n: number, digits = 2) {
  if (n == null) return '—';
  return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function num(n: number) { return n == null ? '—' : Number(n).toLocaleString('en-US'); }

export function plural(n: number, one: string, many = one + 's') { return `${n} ${n === 1 ? one : many}`; }

export function initials(name: string) {
  return String(name || '?').split(/[\s&.]+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

export const titleCase = (s: string) => String(s || '').toLowerCase().replace(/(^|[_\s-])(\w)/g, (_, p, c) => (p ? ' ' : '') + c.toUpperCase());
export const slugStatus = (s: string) => String(s || '').toLowerCase().replace(/[\s_]+/g, '-');
